import React from 'react';
import styles from './Button.module.scss';
import { ButtonProps } from './Button.types';

const buttonStyles = 'button';

const Button: React.FC<ButtonProps> = ({ children, circle = false, className,
  disabled = false, onClick, type = 'button', variant = 'primary' }) => {

  return (
    <button className={[styles[buttonStyles], styles[buttonStyles + '__' + variant],
      className, circle ? styles[buttonStyles + '__circle'] : ''].join(' ')}
      disabled={disabled} onClick={onClick} type={type}>
      {children}
    </button>
  );
};

export default Button;
